/*
  cards-center: visuele feedback op product-card "Toevoegen aan
  winkelwagen" knop na een geslaagde add-to-cart.

  Werkwijze
  - Capture click op .bls__js-addtocart binnen een .bls__product-item
    en onthoud welke knop dat was.
  - Monkey-patch window.fetch: bij een response op /cart/add met
    res.ok (2xx) triggert de 'is-added' state op die knop.
  - 'is-added' laat de knop groen worden met een vinkje-animatie.
    Na 2 seconden verwijdert de class zichzelf weer.

  Deze hook intercept de theme add-to-cart flow NIET — product.min.js
  (initBtnAdd / fetchAddCart) draait ongewijzigd door. Als de fetch
  faalt (out of stock, netwerkfout) blijft de knop rood; dan is de
  groene bevestiging terecht afwezig.

  Staat los van cart-popup-preference.js die ook window.fetch hookt;
  monkey-patches op fetch kunnen gewoon gestapeld worden zolang ze
  elkaars response-chain niet breken.
*/
(function () {
  'use strict';

  if (typeof window === 'undefined' || !('fetch' in window)) return;

  var lastClickedBtn = null;

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.bls__js-addtocart');
      if (!btn) return;
      if (!btn.closest('.bls__product-item')) return;
      lastClickedBtn = btn;
    },
    true
  );

  var origFetch = window.fetch.bind(window);
  window.fetch = function () {
    var args = arguments;
    var url = '';
    if (typeof args[0] === 'string') {
      url = args[0];
    } else if (args[0] && typeof args[0].url === 'string') {
      url = args[0].url;
    }

    if (url.indexOf('/cart/add') === -1) {
      return origFetch.apply(window, args);
    }

    var btnAtClick = lastClickedBtn;
    lastClickedBtn = null;

    return origFetch.apply(window, args).then(function (res) {
      if (res && res.ok && btnAtClick && document.contains(btnAtClick)) {
        triggerAddedState(btnAtClick);
      }
      return res;
    });
  };

  function triggerAddedState(btn) {
    if (btn.classList.contains('is-added')) return;
    btn.classList.add('is-added');
    setTimeout(function () {
      btn.classList.remove('is-added');
    }, 2000);
  }
})();
